import { useEffect, useState } from "react";
import { useCurrentUser, useCentralApi } from "hooks/shared";
import { debounce } from 'lodash';


export type GetAutocompleteResult = {
    workspaceInstanceIds?: string,
    userId: string,
    fullName: string,
    userType?: string,
    isSageUser?: boolean,
    contractorId?: number,
    setAsPrimary?: boolean,
    assignOnInProgress?: boolean
};

type WorkItemResult = [
    GetAutocompleteResult[] | null,
    boolean,
    string | null,
    React.Dispatch<React.SetStateAction<GetAutocompleteResult[] | null>>
];

    const useAutocompleteWorkItemsResource: (searchString: string | undefined) => WorkItemResult = (searchString) => {
    const [ result, setResult ] = useState<GetAutocompleteResult[] | null>(null);
    const [ error, setError ] = useState<string | null>(null);
    const [ loading, setLoading ] = useState<boolean>(true);    
    const user = useCurrentUser();
    const fetcher = useCentralApi(user);

    const fetchResources = async (searchString: string | undefined, controller: any) => { 
    if (user && user.id_token && searchString) {
            setResult(null);
            setLoading(true);
            try {

                const resp = await fetcher(`/api/v3/bulkupdate/workitem/Autocomplete?searchValue=${searchString}`, {
                    signal: controller.signal
                });

                if (!resp.ok) {
                    // RESPOND TO ERRORS
                }

                const data = await resp.json();
                setResult(data.users);
            } catch (err) {
                // TODO: 
            } finally {
                setLoading(false);
            }
        } else {
            setLoading(true);
            setResult([]);
            setLoading(false);
        }
    };
        
        
   const debouncedFetchOptions = debounce(fetchResources, 500); 

    useEffect(() => {        
        const controller = new AbortController();
        debouncedFetchOptions(searchString,controller); // Call debounced function when input value changes
        return () => {
            debouncedFetchOptions.cancel();
            controller.abort();
            setLoading(false);
        };
    }, [ searchString ]);

    return [
        result,
        loading,
        error,
        setResult
    ];
};

export default useAutocompleteWorkItemsResource;